export default __webpack_public_path__ + "static/media/standard_00.dfe1726e.png";